import { FormEvent, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { postJson } from "../api";
import type { ConsumerIntent, SessionUser } from "../types";

const timelines = [
  ["0_3_months", "Within 3 months"],
  ["3_6_months", "3–6 months"],
  ["6_12_months", "6–12 months"],
  ["over_12_months", "More than a year"],
  ["not_sure", "Not sure yet"],
] as const;

function nextPath(value: string | null) {
  return value === "/alerts/new" ? value : "/profile";
}

export function OnboardingPage({ user, onUpdated }: { user: SessionUser; onUpdated: (user: SessionUser) => void }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [intent, setIntent] = useState<ConsumerIntent>(user.intent ?? "researching_permits");
  const [timeline, setTimeline] = useState(user.purchaseTimeline ?? "");
  const [error, setError] = useState("");

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    const name = new FormData(event.currentTarget).get("name");
    try {
      const result = await postJson<{ user: SessionUser }>("/api/profile", {
        name,
        intent,
        purchaseTimeline: intent === "buying_home" ? timeline || null : null,
      });
      onUpdated(result.user);
      navigate(nextPath(params.get("next")), { replace: true });
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Unable to save your profile");
    }
  };

  return <main className="auth-page"><section className="auth-panel onboarding-panel"><h1>Tell us what brings you here</h1><p>This helps us tailor your account. You can change it later.</p><form onSubmit={submit}>
    <label>Full name<input name="name" defaultValue={user.name ?? ""} required autoComplete="name" /></label>
    <fieldset><legend>What are you looking for?</legend><label className={intent === "researching_permits" ? "intent-option selected" : "intent-option"}><input type="radio" name="intent" value="researching_permits" checked={intent === "researching_permits"} onChange={() => setIntent("researching_permits")} /><span><strong>Explore new permits</strong><small>I’m researching what is taking shape around Austin.</small></span></label><label className={intent === "buying_home" ? "intent-option selected" : "intent-option"}><input type="radio" name="intent" value="buying_home" checked={intent === "buying_home"} onChange={() => setIntent("buying_home")} /><span><strong>Buy a new home</strong><small>I’m watching permits as part of an upcoming home search.</small></span></label></fieldset>
    {intent === "buying_home" ? <label>When are you hoping to buy?<select value={timeline} onChange={(event) => setTimeline(event.target.value)} required><option value="">Choose a timeframe</option>{timelines.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label> : null}
    {error ? <p className="form-error">{error}</p> : null}<button className="button primary">Save profile</button>
  </form></section></main>;
}
